(function () {
	'use strict';
	$(document).ready(function () {
		if ($(".products-container").length) {

			function getProducts(filtersData, orderBy, orderDirection, metaKey) {
				$.ajax({
					type: "GET",
					url: fh_config.rest_url + "fh/v1/get-products",
					data: {
						'category_slug': fh_config.queried_object_slug,
						'filters': filtersData,
						'orderby': orderBy,
						'order': orderDirection,
						'key': metaKey,
					},
					headers: {
						'X-WP-Nonce': fh_config.rest_nonce,
					},
					beforeSend: function () {
						$('.products-container').append('<div class="loader"></div>');
					},
					success: function (response) {
						$('.products-container').html(response?.products ?? '');
					},
					error: function (response) {
						console.log(response)
					}
				});
			}



			function handleFilters() {
				const rangeInputs = {}
				const selectValue = document.querySelector('select')?.value;
				const [orderBy, orderDirection, metaKey] = selectValue.split(' ');
				document.querySelectorAll('input[type="range"]').forEach((el) => {
					const name = el.dataset.name;
					const minValue = el.parentElement.querySelector('#fromSlider')?.value;
					const maxValue = el.parentElement.querySelector('#toSlider')?.value;
					const maxRange = el.parentElement.querySelector('#toSlider')?.max;
					const minRange = el.parentElement.querySelector('#toSlider')?.min;

					if (maxValue !== maxRange || minValue !== minRange) {
						rangeInputs[name] = {
							name: name,
							min: minValue,
							max: maxValue,
						};
					}
				});

				getProducts(rangeInputs, orderBy, orderDirection, metaKey)
			}

			const select = document.querySelector('select');
			select.addEventListener('change', () => {
					handleFilters();
			});

			document.querySelectorAll('input[type="range"]').forEach((el) => {
				el.addEventListener('change', () => {
					handleFilters()
				});
			});


			const filters = document.querySelector('.filters');
			filters.querySelector('button').addEventListener('click', () => {
				filters.classList.toggle('open');
			});
		}
	});
}(jQuery));